import { BankConnectionsSection } from '@/components/ledgersync/BankConnectionsSection'
import { ManualBanksSection } from '@/components/manual-banks/ManualBanksSection'
import { FacilityScopeFallback } from '@/components/financial-accounts/FacilityScopeFallback'
import { FinancialAccountsPageHeader } from '@/components/financial-accounts/FinancialAccountsPageHeader'
import { useFacilityScope } from '@/hooks/useFacilityScope'
import { useFacilityScopeBreadcrumb } from '@/components/financial-accounts/useFacilityScopeBreadcrumb'

/**
 * One facility's Financial Accounts page
 * (`/settings/facilities/:facilityId/financial-accounts`), reached from
 * Settings → Facilities: the organization-wide page's Connections and Manual
 * Financial Accounts sections, narrowed to the institutions with an account of
 * this facility and counting only its accounts. An inactive facility's page is
 * read-only.
 */
export function FacilityFinancialAccountsPage() {
  const { scope, isLoading, error, notFound } = useFacilityScope()
  useFacilityScopeBreadcrumb(scope)

  if (scope) {
    return (
      <div className="space-y-6">
        <FinancialAccountsPageHeader scope={scope} />
        <BankConnectionsSection scope={scope} />
        <ManualBanksSection scope={scope} />
      </div>
    )
  }

  return <FacilityScopeFallback isLoading={isLoading} error={error} notFound={notFound} />
}
